<div class="container">

    <header>
        <div class="left">
            <button mat-button routerLink="/inventory"><mat-icon>arrow_back</mat-icon> Inventory</button>
        </div>

        <div class="right mobile-hide">
            <button [disabled]="preventDuplicate" mat-raised-button color="primary" *ngIf="category!=undefined" (click)="createItem(category)">Create {{category.nicename}}</button>
            <button (click)="openItemTemplateEditor()" mat-stroked-button>Settings</button>
            <button color="primary" (click)="openCategoriesDialog()" mat-raised-button>Categories</button>
        </div>
    </header>


    <button [disabled]="preventDuplicate" (click)="createItem(category)" class="add-item desktop-hide" mat-fab color="primary">
        <mat-icon>add</mat-icon>
    </button>

    <div class="tabs">
        <div class="left">
            <button [class.active]="activeTab=='active'" (click)="activateTab('active')" mat-button>Active ({{itemsForSale.length}})</button>
            <button [class.active]="activeTab=='needs-attention'" (click)="activateTab('needs-attention')" mat-button>Needs Attention ({{itemsNeedImprovement.length}})</button>
            <button [class.active]="activeTab=='checked-out'" (click)="activateTab('checked-out')" mat-button>Checked out ({{itemsCheckedOut.length}})</button>
        </div>
    
        <div class="center">

        </div>
    
        <div class="date-range-colume">

        </div>
    </div>

    <div class="stats">
        <div class="listed">
            Listed
            <p>{{listedItems}}</p>
        </div>
        <div class="unlistedLabel" (click)="showUnlistedOnly()">
            Not Listed
            <p>{{unlistedItems}}</p>
        </div>
        <div class="search">
            <ap-search alignRight="true" (onChange)="filter($event)" (cancelled)="filterCancelled()"></ap-search>
        </div>
    </div>

    <div class="no-records" *ngIf="!loading && dataSource.filteredData.length == 0">
        No items
    </div>

    <div class="table-content columns">
        <!-- <div class="left">
            <div *ngFor="let type of types"><a [routerLink]="['/inventory/c', type.name]">{{type.nicename}}</a></div>
        </div> -->

        <div class="right">
            <table class="inventory" mat-table [dataSource]="dataSource" multiTemplateDataRows>

                <!-- Column Headers -->
                <ng-container matColumnDef="image">
                    <td class="image-column" mat-cell *matCellDef="let item">
                        <div (click)="viewItem(item)" [style]="getPlaceholder()" class="placeholder">
                            <div [style]="getImage(item)" class="placeholder2"></div>
                        </div>
                    </td>
                </ng-container>                    

                <ng-container matColumnDef="code">
                    <td class="code-column" mat-cell *matCellDef="let item">
                        <div class="code"><span class="pound">#</span>{{item.number}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="title">
                    <td class="title" mat-cell *matCellDef="let item; let i = dataIndex;" (click)="viewItem(item, i)">
                        <div class="title-text">
                            <span matTooltip="Needs improvement" *ngIf="item.status == 'Needs Improvement'">⚠️</span>
                            <span matTooltip="Pending Review" *ngIf="item.status == 'Pending Review'">☑️</span>
                            <span class="code desktop-hide"><span class="pound">#</span>{{item.number}}</span>
                            {{getTitle(item.title)}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="value">
                    <td mat-cell *matCellDef="let item">
                        {{item.decision}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="salesChannels">
                    <td class="salesChannels" mat-cell *matCellDef="let item">
                        <div class="channel-links">
                        <ng-container *ngIf="item.status == 'Sold'">
                            SOLD
                        </ng-container>
                        <ng-container *ngIf="item.status != 'Sold'">
                            <a *ngIf="item.webflow && item.webflow.isListed" target="_blank"><span><img height="20" src="assets/icons/webflow.png"></span></a>
                            <a *ngIf="item.facebook && item.facebook.url != ''" target="_blank" [href]="item.facebook.url"><span><img height="20" src="assets/icons/facebook.png"></span></a>
                            <a *ngIf="item.ebay && item.ebay.ItemID != 0" target="_blank" [href]="'https://ebay.com.au/itm/' + item.ebay.ItemID"><span><img height="20" src="assets/icons/ebay.png"></span></a>
                        </ng-container>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="stockTake">
                    <td mat-cell *matCellDef="let item">
                        {{item.stockTake | date:'dd-MM-yy'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="dateListed">
                    <th class="amount" mat-header-cell *matHeaderCellDef>Last Modified</th>
                    <td class="amount" mat-cell *matCellDef="let item">
                        {{item.lastModified | timeago}}
                    </td>
                </ng-container>

                <tr class="inventory-row"
                    [class.sold]="item.status=='Sold'"
                    apStatus="View item"
                    mat-row
                    *matRowDef="let item; let i = dataIndex; columns: columnsToDisplay2;">
                </tr>
            </table>
        </div>
    </div>
</div>